<div class="bw-credit-history-line-chart-legacy" *ngIf="data?.length">
  <highcharts-chart
    *ngIf="_showChart"
    [Highcharts]="Highcharts"
    [options]="chartOptions"
    [update]="true"
    (chartInstance)="onChartInstance($event)"
    style="width: 100%; height: 200px; display: block;"
  ></highcharts-chart>
</div>
